import type { JSX } from "react";
import { routes } from "../../../app/routes/routes";
import ShipmentsIcon from "../../../images/icons/navMenu/shipments.svg?react";
import MySuggestionsIcon from "../../../images/icons/navMenu/mySuggestions.svg?react";
import AddressBookIcon from "../../../images/icons/navMenu/addressBook.svg?react";
import ProfileIcon from "../../../images/icons/navMenu/profile.svg?react";
import SupportIcon from "../../../images/icons/navMenu/support.svg?react";
import { BsBell } from "react-icons/bs";

interface NavItemConfig {
    key: string;
    route: string;
    icon: JSX.Element;
    labelKey: string;
    requireAuth?: boolean;
}

export const sideNavItems: NavItemConfig[] = [
    {
        key: "profile",
        route: routes.profile.path,
        icon: <ProfileIcon title="Profile icon" />,
        labelKey: "profile",
        requireAuth: true,
    },
    {
        key: "myOrders",
        route: routes.myOrders.path,
        icon: <ShipmentsIcon title="My orders icon" />,
        labelKey: "myOrders",
        requireAuth: true,
    },
    {
        key: "mySuggestions",
        route: routes.mySuggestions.path,
        icon: <MySuggestionsIcon title="My suggestions icon" />,
        labelKey: "mySuggestions",
        requireAuth: true,
    },
    {
        key: "addressBook",
        route: routes.addressBook.path,
        icon: <AddressBookIcon title="Address book icon" />,
        labelKey: "addressBook",
        requireAuth: true,
    },
    {
        key: "support",
        route: routes.support.path,
        icon: <SupportIcon title="Support icon" />,
        labelKey: "support",
        requireAuth: true,
    },
    {
        key: "notifications",
        route: routes.notifications.path,
        icon: <BsBell style={{ minHeight: "24px", minWidth: "24px" }} />,
        labelKey: "notifications",
        requireAuth: true,
    },
];
